
  <div  class="new-msg-wrapper" #wrapper fileDragEnter (dragover)="onDragOver($event)" (dragenter)="onDragOver($event)" 
  (dragleave)="onDragLeave($event)" >
    <div class="mobile-sidebar">
      <form class="form-horizontal mobile-order3" [formGroup]="newMessageForm" style="height: 100%; display: flex;flex-direction: column;">
        <new-message-actions class=" mobile-order2" [parentForm]="newMessageForm" [editorData]="child" [tabName]="tabNameNMC"
          [fromNewMessage]="fromNewMessage" (getAttachments)="getAttachments($event)"
          (notesEvent)="onNote($event, 'reply')" [notes]="notesList" [secure]="secure" (setResolve)="setResolve($event)"
          (toBccData)="getToBccData($event)" (formatTemplate)="getTemplate($event)" [messageInstance]="messageInstance"
          [conversationObj]="conversationObj" [group]="group" [isInlineReply]="isInlineReply"
          (cancelInlineReply)="cancelInlineAction()" (inlineReplySend)="onNewMessageSend($event)"
          (inlineReplyScheduled)="onInlineReplyScheduled($event)" [selectedCLCTrades]="selectedCLCTrades"
          [inlineImageAttached]="inlineImage" [recipientUpdate]="recipientUpdated" [updatePrevAttach]="hasPrevAttach"
          [horizontalStyle]="horizontalStyle" [isFormatOpen]="isFormatOpen" (filePreviewsMapChange)="updateFilePreviewsMap($event)" #newMessageAction>
        </new-message-actions>
        <div [style.overflow-y]="(horizontalStyle || isInlineReply) ? 'auto' : 'visible'"
          [style.max-height]="(horizontalStyle || isInlineReply) ? 'calc(100vh - 30px)' : 'none'"
          [style.padding-bottom]="(horizontalStyle || isInlineReply) ? '20px' : '0'">
          <new-message-recipent class=" mobile-order" [parentForm]="newMessageForm" [editorData]="child"
          (notesEvent)="onNote($event, 'new')" (resizeMailBody)="resizeBody($event)" [fromNewMessage]="fromNewMessage"
          [postDataForAttachment]="postDataForAttachmentFileN" (secure)="updateSecure($event)" [resolve]="setResolveN"
          [toCcBccData]="toBccData" [template]="template" [messageInstance]="messageInstance" [pushContact]="pushContact"
          (messageContent)="setMessageData($event)" (conversationObj)="getConversationObj($event)"
          (disclaimerEvent)="onDisclaimerChange($event)" (group)="onGroupChange($event)" [isInlineReply]="isInlineReply"
          (expandEvent)="onExpandEvent($event)" (window:resize)="resize()"
          (newMessageData)="onNewMessageDataChanged($event)" (topContactAddEvent)="onTopContactAdded($event)"
          (recipientUpdateEvent)="onRecipientUpdate($event)" #newMessageRecipent [inboxView]="inboxView"
          (updatePrevAttach)="updatePrevAttach($event) " [attachments]="getAttachmentsArray()" [parentComponent]="this">
        </new-message-recipent>
          <div class="mobile-order1" style="height: 100%;" (dragover)="onDragOver($event)" (dragenter)="onDragOver($event)"                                   
        >
            <div class="dragArea" *ngIf="borderDragDropHighlight"
            (drop)="onDrop($event)"
            (dragover)="onDragOver($event)" (dragenter)="onDragOver($event)"
            >
              <div class="dropText">Drop files here</div>
            </div>
            <div *ngIf="!borderDragDropHighlight" style="height: 45vh; padding-bottom: 10px;" (dragover)="onDragOver($event)" (dragenter)="onDragOver($event)">
              <editor-app (onLoad)="onEditorLoad()" [elementId]="'my-editor'+countID" [height]="400"
              class="my-editor" [ngClass]="isFormatOpen ? '': 'hideToolbar'"  (inlineImage)="inlineImagePresent($event)"
              [skip_focus]="skip_focus" (onBlur)="editorDataChange()"  [fromNewMessage]="fromNewMessage" [horizontalStyle]="horizontalStyle" (filePasted)="triggerPastedFile()" (editorDrag)="handleDragFromEditor()" style="height: 100%; display: inline-block; width: 100%;"> </editor-app>
            </div>
            
          </div>
          </div>
      </form>
    </div>

    <!-- <contact-sidebar *ngIf="showContactSidebar && isPanelPinned" [note]="notesList" [clc]="clc" (tradeAdded)="onTradesAdded($event)"
      (contactEvent)="onPushContact($event)" [rightSideBar]="'auto'" [topContactAdd]="topContactAdded"
      [messageInstance]="messageInstance" [checkTaskizeInquiry]="isTaskizeInquiry" (openSidePanel)="openSidePanel.emit()" (setActiveIndex)='setActiveIndex($event)'>
    </contact-sidebar>
    <app-contact-sidepanel [isVisible]="sidePanelOpen" [note]="notesList"  [clc]="clc"
      [inboxViewMode]="inboxView" [screen]="'inbox'"
      (tradeAdded)="onTradesAdded($event)"
      (contactEvent)="onPushContact($event)"
      [isTaskizeInquiry]="isTaskizeInquiry" (closeSidePanel)="onCloseSidePanel($event)"  (openSidePanel)="openSidePanel.emit()" [activeIndex]="activeIndex">
    </app-contact-sidepanel>
    <div *ngIf="sidePanelOpen" class="sidePanelClose" pTooltip="Close"
      tooltipPosition="top"
      tooltipStyleClass="rightTooltip p-tooltip-text">
      <img [src]="'assets/Inbox/sidePanelClose.svg'" alt="Close" class="closeIcon" />
    </div> -->


  </div>